// extracted by mini-css-extract-plugin
export default {"popupClose":"UndoChanges_popupClose__a8nyb"};